import { render, staticRenderFns } from "./GrupoSegurancaFormDialog.vue?vue&type=template&id=679d37ac&"
import script from "./GrupoSegurancaFormDialog.vue?vue&type=script&lang=js&"
export * from "./GrupoSegurancaFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports